import React , { useState} from 'react'
import Modal from 'react-bootstrap/Modal'
import {Row, Col, Form, InputGroup, Button, Alert, Spinner} from 'react-bootstrap'
import {    FontAwesomeIcon    } from '@fortawesome/react-fontawesome'
import {faCheck , faVideo} from '@fortawesome/free-solid-svg-icons'
import {Oferente} from  '../models/Oferente'
import {LicitacionInscripcion} from  '../models/LicitacionInscripcion'
import {Licitacion} from  '../models/Licitacion'
import { OdooDataInscription } from '../models/OdooResponse';
import './ComponentLicitacionModalOferentes.scss'
import Config from '../config/default.json'

interface FormModalProps{
    show: Boolean,
    showSub: boolean,
    licitacion: Licitacion,
    handleClose: ()=>void,
}

const ComponentLicitacionModalOferentes: React.FC<FormModalProps> =(props)=>{
    const [oferenteData, setOferenteData]           = useState<Oferente>({name:'',email:'',mobile:'',vat:''})
    const [inscriptoData, setInscriptoData]         = useState<LicitacionInscripcion>({name:'',empresa_name:'',pliego:''})
    const [showAlertw, setshowAlertWar]             = useState(false)
    const [showAlerReq, setshowAlertReq]            = useState(false)
    const [showAlertS, setShowAlertUp]              = useState(false)
    const [hiddenForm, setHiddenForm]               = useState(false)
    const [disableFields, setdisableFields]         = useState(false)
    const [FileType, setFileType]               = useState("")

    
    const [swSpinnerInscripcion, setswSpinnerInscripcion]     = useState(false);
    const fa_check                      = <FontAwesomeIcon icon={faCheck} />
    const fa_viewo                      = <FontAwesomeIcon icon={faVideo} />
    const handleClose = () =>{
        setswSpinnerInscripcion(false)
        setHiddenForm(true)
        setshowAlertWar(false)
        setShowAlertUp(false)
        setshowAlertReq(false)
        props.handleClose()
        
    }
    
 
    const setNewOferente =()=>{
    
      setswSpinnerInscripcion(true)
      setdisableFields(true)
      setshowAlertReq(false)
      setshowAlertWar(false)
      if (oferenteData.name  && oferenteData.vat && oferenteData.email && oferenteData.mobile && inscriptoData.pliego){
        let requestOptions = {
            method  : 'POST',
            headers : {
                    'Accept'        : 'application/json',
                    'Content-Type'  : 'application/json'
            },
            body    : JSON.stringify({ "licitacion_id"      : props.licitacion.id,
                                       "name"               : oferenteData.name,
                                       "vat"                : oferenteData.vat, 
                                       "email"              : oferenteData.email,
                                       "mobile"             : oferenteData.mobile,
                                       "pliego"             : inscriptoData.pliego,
                                       'mimeType'           : FileType
                                    }),    
        };
        fetch(Config.Production.Host.url+'/licitaciones/newoferetente',requestOptions).then((response) => {
            return response.json();
        }).then((respuesta: OdooDataInscription) => {
          setTimeout(() => {
           
            if (respuesta.result){
              setshowAlertReq(false)
              setshowAlertWar(false)
              setHiddenForm(true)
              setShowAlertUp(true)
              setInscriptoData(respuesta.result)
              setOferenteData({name:'',email:'',mobile:'',vat:''})
              setdisableFields(false)
              setswSpinnerInscripcion(false)
            }else{
              setshowAlertWar(true)
              setdisableFields(false)
              setswSpinnerInscripcion(false)
            }
          }, 550);
        }); 
      }else{
        setdisableFields(false)
        setswSpinnerInscripcion(false)
        setshowAlertReq(true)
        setshowAlertWar(false)
        setShowAlertUp(false)
      }
     

      
    }

    const spinnerInscrip               = swSpinnerInscripcion? <Spinner animation="border" variant="success" className="spinner-inscrip"/>:""
    const alert_exist_inscripcion= <Alert variant="warning" show={showAlertw} className="alert-warning" onClose={() => setshowAlertWar(false)} dismissible>
                                    <Alert.Heading>Atención!</Alert.Heading>
                                      <p>
                                      </p>
                                      <hr />
                                       <p><strong>{oferenteData.name}{' '} ya se encuentra inscripto en esta licitacion.</strong>.</p>
                                    </Alert>

    const alert_required_fields= <Alert variant="warning" show={showAlerReq} className="alert-warning" onClose={() => setshowAlertReq(false)} dismissible>
                                  <Alert.Heading>Atención!</Alert.Heading>
                                    <p>
                                    </p>
                                    <hr />
                                     <p><strong>Todos los campos son obligatorios.</strong>.</p>
                                  </Alert>

    const alert_succceful_update=   <Alert variant="success" className="alert-succes" show={showAlertS} onClose={() => setShowAlertUp(false)} dismissible>
                                        <Alert.Heading>Inscripción a la licitacion {' '} {props.licitacion.name}{' '} ha sido un exito.</Alert.Heading>
                                        <p>
                                        </p>
                                        <hr />
                                        <p className="mb-0">
                                          {oferenteData.name + ' '} Se ha inscripto correctamente a la licitacion.
                                        </p>
                                    </Alert>
    const setFilePliego=(e: React.ChangeEvent<HTMLInputElement>)=>{
      let files = e.currentTarget.files;

      if (files){
        for (var i = 0; i < files.length; i++) {
          let file = files[i];
          // Make new FileReader
          let reader = new FileReader();
          // Convierto el texto a base64
          reader.readAsDataURL(file);
          reader.onload = () => {
            setInscriptoData({...inscriptoData, 'pliego':reader.result})
              let fileInfo = {
                name: file.name,
                type: file.type,
                size: Math.round(file.size / 1000) + ' kB',
                base64: reader.result,
                file: file,
              };
              setFileType(fileInfo.type)
          }
          
        }
      }
    }
    return(
      <Modal
        size="lg"
        show={props.show?true:false}
        onHide={handleClose}
        prop={false}
      >
        <Modal.Header closeButton className="modal-licitacion-header" >
          <Modal.Title id="modal-form-title" hidden={showAlertS}>
          <p id="header-text">Se esta inscribiendo en la Licitación
             <strong>{" " + props.licitacion.name}</strong></p>
             
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid" hidden={showAlertS}>
        <Row>
            <Col xs={12} md={12}>
              <Form noValidate hidden={props.showSub === false}>
                
                  <Form.Group as={Col} md="9" controlId="validationFormik101">
                    <Form.Label>Apellido y Nombre</Form.Label>
                    <Form.Control
                    readOnly={disableFields}
                      required
                      type="text"
                      name="name"
                      placeholder="Apellidos y Nombres"
                      value={oferenteData?.name}
                      onChange={e => setOferenteData({...oferenteData, 'name':e.currentTarget.value})}
                    />
                    <Form.Control.Feedback tooltip>Looks good!</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="3" controlId="validationFormikUsername2">
                    <Form.Label>CUIT</Form.Label>
                    <InputGroup>
          
                      <Form.Control
                      readOnly={disableFields}
                        required
                        type="text"
                        placeholder="CUIT"
                        aria-describedby="inputGroupPrepend"
                        name="dni"
                        value={oferenteData?.vat}
                        onChange={e => setOferenteData({...oferenteData, 'vat':e.currentTarget.value})}
                      />
                      <Form.Control.Feedback type="invalid" tooltip>
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
               
                {spinnerInscrip}
                
                  <Form.Group as={Col} md="6" controlId="validationFormik103" >
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                    readOnly={disableFields}
                      required
                      type="text"
                      placeholder="Email"
                      name="email"
                      value={oferenteData?.email}
                      onChange={e => setOferenteData({...oferenteData, 'email':e.currentTarget.value})}
                    />

                    <Form.Control.Feedback type="invalid" tooltip>
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} md="6" controlId="validationFormik104">
                    <Form.Label>Celular</Form.Label>
                    <Form.Control
                    readOnly={disableFields}
                      required
                      type="text"
                      placeholder="Celular"
                      name="mobile"
                      value={oferenteData?.mobile}
                      onChange={e => setOferenteData({...oferenteData, 'mobile':e.currentTarget.value})}
                    />
                    <Form.Control.Feedback type="invalid" tooltip>
             
                    </Form.Control.Feedback>
                  </Form.Group>
                 
                  <Form.Group as={Col} md="6" controlId="file" >
                  <div className="form-group">
                    <label className="form-label">
                      Pliego
                    </label>
                    <input placeholder="Archivo"
                          disabled={disableFields}
                           name="archivo"
                           type="file"
                           id="validationFormik104"
                           onChange={e=>setFilePliego(e)}
                           className="form-control-file"/>
                    
                  </div>
                  </Form.Group>
                  <Form.Group as={Col} md="6" controlId="tutorial" >
                  <br></br>
                    <a href="https://youtu.be/UGrSmNtowbo" className="redirect-tuto" target="_blank">{fa_viewo }{" "}Tutorial: cómo cifrar un archivo Winzip y subirlos a la pagina.</a>
                  </Form.Group>
                              
                 <Form.Group as={Col} md="6" controlId="button" >
                
                    <Button onClick={setNewOferente} disabled={disableFields}>{fa_check}{' '}Inscribirse</Button>
                </Form.Group>
                
              </Form>
             
            </Col>
          </Row>
        </Modal.Body>
            {alert_exist_inscripcion}
            {alert_succceful_update}
            {alert_required_fields}
      </Modal>
      )
}

export default ComponentLicitacionModalOferentes